<div class="modal-header bg-{{ type }} py-1" *ngIf="title">
  <h4 class="modal-title pull-left">{{ title }}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p>{{ message }}</p>

  <div class="w-100 text-center">    
    <button type="button"  mat-raised-button (click)="onClose()" >OK!</button>
  </div>
  
</div> 